module.exports = __webpack_public_path__ + "img/no 7.5b41d5e5.png";